export function infoSlider() {
    let slider = $(".info-slider .slider");
    let duration;
    slider.slick({
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'ease-in-out',
        arrows: false,
        dots: true
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        let slide = $(".slick-slide").eq(currentSlide);
        console.log(slide);
        if (slide.find(".number")) {
            slide.find(".number").each(function (){
                let $this = $(this);
                let number = $this.find("span");
                duration = number.data("speed");
                number.prop('Counter', 0).animate({
                    Counter: number.text()
                }, {
                    duration: duration,
                    easing: 'swing',
                    step: function (now) {
                        number.text(Math.ceil(now));
                    }
                });
            })

        }
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/infoSlider.js